import React from "react";

const BottomSaveContainer = ( props:{ onSave: () => void }) => {

    return (
        <div className="bottomSaveConteiner">
            <div className="inner flex between">
                <div className="btn saveActionBtn" onClick={props.onSave}>
                    Сохранить изменения
                </div>
            </div>
        </div>
    )
}

export default BottomSaveContainer;